import React from 'react';
import _ from 'root/libs/exaforte/react/lodash';
import { View, Text } from 'react-native';
import CustomComponent from 'root/libs/exaforte/react/CustomComponent';
import DataModel from 'root/libs/exaforte/react/DataModel';
import Config from 'root/globals/Config';
import Components from 'root/Components';
import { ContentDialog } from 'root/globals/Dialog';
import { CustomSelect } from 'root/libs/exaforte/react/Form';
import CustomForm from 'root/libs/exaforte/react/form/CustomForm';
import { ButtonGroup, Button } from 'root/globals/Elements';
import { BasicBlockView } from 'root/globals/Elements';
import TouchableArea from 'root/libs/exaforte/react/TouchableArea';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
    faPlus,
    faTimes,
} from '@fortawesome/pro-regular-svg-icons';

import defaults from 'root/globals/Defaults.less';
import export_dialog from './ExportDialog.less';

const styles = {...defaults, ...export_dialog};

export default class ExportDialog extends CustomComponent {
    constructor(props) {
        super(props);
        
        this.state          = {step: 1, selected_fields: [], export_type_id: 0, export: props.controller.component.state.filter};
        const data_model    = this.getFilterModelClass();
        this.data_model     = new data_model(this, {name: 'export'});

        this.data_model.set_fields(props.search_fields || props.controller.config.filter.config.fields);

        // Als er geen velden zijn om op te zoeken kunnen we net zo goed direct
        if(_.is_empty(this.data_model.get_fields()))
            this.state.step = 2;
    }
    
    getFilterModelClass() {
        return this.props.filter_model_class || DataModel;
    }
    
    _toggleStep() {
        this.setState({step: (this.state.step == 1 ? 2 : 1)});
    }
    
    _download() {
        window.location.href = Config.IMAGES_URL + 'export-' + (_.isArray(this.props.component) ? this.props.component[0] : this.props.component) + '.xlsx?' + btoa(JSON.stringify({export: this.state.export, export_type_id: this.state.export_type_id, selected_fields: this.state.selected_fields}));
    }
    
    _exportTemplateFormat(models) {
        models.unshift({id: 0, title: 'Excel'});
        
        return this.props.controller._asSelectList(models);
    }
    
    _changeExportType(value) {
        this.setState({export_type_id: value});
    }
    
    _toggleField(field) {
        this.setState({selected_fields: _.xor(this.state.selected_fields, [field])});
    }
    
    render() {
        let actions;
        
        if(this.props.closeCallback)
            actions = <ButtonGroup buttons={[{title: 'Sluiten', secondary: true, onPress: this.props.closeCallback, className: ['ml-2']}]} />;

        let export_templates = this.props.controller.get_data({models: [Components.__EXPORT_TEMPLATE_COMPONENT__], format: this._exportTemplateFormat, filter_field: {component_ids: {value: model => (model.id == 0 || _.is_value_in_set(model.component_ids, (_.isArray(this.props.component) ? this.props.component[0] : this.props.component))), type: 'function'}}, after_format_sort: [{field: 'label'}]});

        return <ContentDialog title={'Exporteren'} actions={actions} maxWidth={'sm'}>
            {this.state.step == 1 && <>
                <Text className={[styles['f-1-2-5'], styles['color-dark-grey'], styles['text-light'], 'pb-3']}>Maak in het filter hieronder een selectie van de gegevens die je wilt exporteren.</Text>
                <CustomForm model={this.data_model} fielddefines={this.data_model.get_fields()} />
                <View className={['justify-content-end d-flex']}>
                    <Button onPress={this._toggleStep}>Volgende</Button>
                </View>
            </>}
            {(this.state.step == 2 && _.size(export_templates) > 1) && <>
                <Text className={[styles['f-1-2-5'], styles['color-dark-grey'], styles['text-light'], 'pb-3']}>Kies een formaat waarin je de gegevens wilt exporteren.</Text>
                <CustomSelect label={'Export formaat'} onChangeText={this._changeExportType} value={this.state.export_type_id} options={export_templates} mandatory={true} />
            </>}
            {(this.state.step == 2 && this.state.export_type_id == 0) && <>
                <Text className={[styles['f-1-2-5'], styles['color-dark-grey'], styles['text-light'], 'pb-2' + (_.size(export_templates) > 1 ? ' pt-4' : '')]}>Kies de velden die je in de export wilt meenemen als kolommen.</Text>
                <ExportDialogFieldSelect export_fields={this.props.controller.component.state.action_fielddefines.export} selected_fields={this.state.selected_fields} toggleField={this._toggleField} user={this.props.user}  />
            </>}
            {this.state.step == 2 && <View className={['justify-content-between d-flex mt-4']}>
                <Button onPress={this._toggleStep} secondary={true}>Vorige</Button>
                <Button onPress={this._download} disabled={_.is_empty(this.state.selected_fields) && this.state.export_type_id == 0}>Exporteren</Button>
            </View>}
        </ContentDialog>;
    }
}

export class ExportDialogFieldSelect extends CustomComponent {
    constructor(props) {
        super(props);
        
        this.state          = { height: null };
        this.container_ref  = React.createRef();
    }
    
    componentDidMount() {
        if(this.container_ref.current)
            this.setState({ height: this.container_ref.current.offsetHeight }, this.props.afterSetHeight);
    }
    
    _renderOption(fielddefine, i) {
        return (
            <BasicBlockView key={i} className={['p-2 mb-2 d-flex flex-row justify-content-between']}>
                <Text className={[styles['text-ellipsis'], styles['f-1-5']]}>{fielddefine.label}</Text>
                <TouchableArea onPress={this.props.toggleField} onPressParams={fielddefine.field} onPressWithEvent={false}>
                    <View className={['d-flex align-items-center justify-content-center ml-2', styles['border-radius-100'], styles['background-color-' + (fielddefine.selected ? 'red-pink' : 'light-blue')], styles['color-white'], styles['f-1-5']]} style={{width: 22, height: 22}}><FontAwesomeIcon icon={fielddefine.selected ? faTimes : faPlus} /></View>
                </TouchableArea>
            </BasicBlockView>
        );
    }
    
    render() {
        let unselected_fields   = [];
        let selected_fields     = [];
        
        for(let i in this.props.export_fields)
        {
            let fielddefine = this.props.export_fields[i];
            
            if(fielddefine.isvisible != 1)
                continue;

            if(this.props.user && !_.is_allowed_action({ action: 'export', actions: fielddefine.actions, items: this.props.user.action_items, user: this.props.user.id, group: this.props.user.group_id }) && fielddefine.show_value_when_no_rights != 't')
                continue;
            
            if(_.includes(this.props.selected_fields, fielddefine.field))
                selected_fields.push({ ...fielddefine, sortnumber: parseInt(fielddefine.sortnumber), selected: true });
            else
                unselected_fields.push({ ...fielddefine, sortnumber: parseInt(fielddefine.sortnumber), selected: false });
        }
        
        return (
            <View className={['flex-row d-flex']} {...(this.state.height && { style: { height: this.state.height } })} forwardedRef={this.container_ref}>
                <View className={['px-2 pt-2 pb-5', styles['not-in-export-file'], styles['flex-10'], styles['background-color-grey-10']]}>{_.map(_.sortBy(unselected_fields, ['sortnumber']), this._renderOption)}</View>
                <View className={[styles['flex-1']]}></View>
                <View className={['px-2 pt-2 pb-5', styles['in-export-file'], styles['flex-10'], styles['background-color-grey-10']]}>{_.map(_.sortBy(selected_fields, ['sortnumber']), this._renderOption)}</View>
            </View>
        );
    }
}